import DefaultLayout from '@/layout/default/index.vue'
import type { RouteRecordRaw } from 'vue-router'

const CrossRoutes: RouteRecordRaw[] = [
  {
    name: 'Cross',
    path: '/cross',
    redirect: '/cross/receipt',
    meta: {
      title: '跨境中心',
      order: 5,
    },
    component: DefaultLayout,
    children: [{
      path: 'receipt',
      name: 'CrossReceipt',
      component: () => import('@/views/wujie.vue'),
      meta: {
        title: '跨境收款(结收汇)',
        icon: 'icon-currency-yen',
        devUrl: 'http://localhost:8008/cross/receipt',
        url: `${window.location.origin}/merchant-platform/micro-funds/cross`,
        isTopLevel: true,
        permission: ['OVERSEAS_BATCH_PAY'],
      },
    }, {
      path: 'bank-card',
      name: 'CrossBankCard',
      component: () => import('@/views/wujie.vue'),
      meta: {
        title: '跨境批付银行卡',
        icon: 'icon-bank-card',
        devUrl: 'http://localhost:8008/cross/bank-card',
        url: `${window.location.origin}/merchant-platform/micro-funds/cross/bank-card`,
        isTopLevel: true,
        permission: ['BATCH_OVERSEAS_REMITTANCE'],
      },
    }, {
      path: 'bank-account',
      name: 'CrossBankAccount',
      component: () => import('@/views/wujie.vue'),
      meta: {
        title: '银行账户收款',
        icon: 'icon-zhuanru',
        devUrl: 'http://localhost:8008/cross/bank-account',
        url: `${window.location.origin}/merchant-platform/micro-funds/cross/bank-account`,
        isTopLevel: true,
        permission: ['COLLECT_PAYMENT_RECORD'],
      },
    }, {
      path: 'account',
      name: 'CrossAccount',
      component: () => import('@/views/wujie.vue'),
      meta: {
        title: '账户备案',
        icon: 'icon-zizhigengxin',
        devUrl: 'http://localhost:8008/cross/account',
        url: `${window.location.origin}/merchant-platform/micro-funds/cross/account`,
        isTopLevel: true,
        permission: ['FOREIGN_ACCOUNT_RECORD'],
      },
    },
    ],
  },
]

export default CrossRoutes
